import "./body.scss"; import "./lang_switch.scss"

